import React from 'react'
import Main from '../../Main'
import Login from './Login'
import WebService from 'api/explus-api'

class LoginContainer extends React.Component {

 refer =''
  constructor(props) {
    super(props)

    const params = new URLSearchParams(window.location.search) // id=123
    let id = params.get('refer') // 123 
    this.refer = id


    this.state = {
      email: '',
      password: '',
      submitting: false,
      refer:id,
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)

   

  }
  

  componentWillMount() {
    if (localStorage.getItem('token')) {
    
      if(this.refer =='ambassador'){
        this.props.history.push('/dashboard/ambassador')
      }else{
        this.props.history.push('/')
      }
    } else {
      this.props.history.push('/login')
    }
  }

  handleChange(event) {
    const target = event.target
    const value = target.value
    const name = target.name

    this.setState({ [name]: value })
  }

  handleSubmit(e) {
    e.preventDefault()
    this.setState({loading: true})

    WebService.Login(this.state).then(() => {
      this.setState({loading: false})
    })
  }

  render() {
    return (
      <Main bannerImage={this.props.bannerImage}>
        <Login 
        handleChange={this.handleChange} 
        handleSubmit={this.handleSubmit}
        loading={this.state.loading}
        user={this.state}/>
      </Main>
    )
  }

}



export default LoginContainer
